import { t } from "../../features/store-language/i18n.ts";
import React from "react";
import { Button, Result } from "antd";

interface AppErrorBoundaryProps {
  children: React.ReactNode;
}

interface AppErrorBoundaryState {
  hasError: boolean;
}

class AppErrorBoundary extends React.Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  public state: AppErrorBoundaryState = { hasError: false };

  public static getDerivedStateFromError(): AppErrorBoundaryState {
    return { hasError: true };
  }

  public render(): React.ReactNode {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <Result
        status="500"
        title={t("نمایش این صفحه کامل نشد؛ صفحه را دوباره بارگذاری کنید.")}
        extra={
          <Button
            type="primary"
            onClick={function () { window.location.reload(); }}
          >
            {t("بارگذاری دوباره")}
          </Button>
        }
      />
    );
  }
}

export default AppErrorBoundary;
